import { StatusEmissao } from "../enums/StatusEmissaoEnum";

export const OptionsStatusEmisssao = [
  { label: "Emitido", value: StatusEmissao.Emitido },
  { label: "Processando", value: StatusEmissao.Processando },
  { label: "Falha", value: StatusEmissao.Falha },
  { label: "Dados Inconsistentes", value: StatusEmissao.DadosInconsistentes },
  {
    label: "Exercício Indisponível",
    value: StatusEmissao.ExercicioIndisponivel,
  },
];
